import { ATTACK_RENAME_MAP } from '../data/generated/attack.generated';

// Normalise any ATT&CK id onto the enterprise-attack.json anchor (SAD §4.2,
// ADR-9). Mapping datasets target older ATT&CK versions (NIST 16.1, KEV 19.0);
// a technique referenced under a since-revoked id must resolve to its current
// entity, not produce a phantom orphan. Control-id padding is handled in the
// transforms (AC-03 → AC-3), not here.
export function normaliseAttackId(id: string): string {
  return ATTACK_RENAME_MAP[id] ?? id;
}
